import { Directive, HostBinding, Input } from '@angular/core';

import { isThemeColor, ThemeColor } from '../../../types/theme';

@Directive({
  selector: '[luiThemeColor]',
  standalone: true,
})
export class ThemeColorDirective {
  @HostBinding('class') colorClass!: { [key: string]: string };
  @HostBinding('style.--secondary-color') get _secondaryColor() {
    return isThemeColor(this.secondaryColor)
      ? `var(--${this.secondaryColor})`
      : undefined;
  }

  @Input() secondaryColor!: ThemeColor | 'default';
  @Input() get color(): ThemeColor | 'default' {
    return this._color;
  }
  set color(value: string) {
    if (isThemeColor(value)) {
      this.colorClass = {
        [`theme-color-${value}`]: value,
      };
      this._color = value;
    }
  }
  private _color!: ThemeColor;
}
